import { FileData } from 'api/file/file.types';
import { FC } from 'react';
import styled from 'styled-components';
import { NoAvatar } from 'ui/Menu/assets/ItemsIcons';

interface AvatarProps {
    url?: string;
    size?: 's' | 'm';
}

const size = {
    s: {
        width: '85px',
        height: '85px'
    },
    m: {
        width: '100px',
        height: '100px'
    }
};

export const StyledAvatar = styled.div<AvatarProps>`
    width: ${(props) => size[props.size || 's'].width};
    height: ${(props) => size[props.size || 's'].height};
    box-sizing: border-box;
    border: 1px solid rgb(113, 142, 191);
    border-radius: 6px;
    background-image: url(${(props) => props.url});
    background-repeat: no-repeat;
    background-size: cover;
`;

export const TableAvatarContainer = styled.div`
    display: flex;
    justify-content: center; /* Центрирование по горизонтали */
    align-items: center; /* Центрирование по вертикали */
    width: 60px; /* Установите ширину контейнера */
    height: 60px; /* Установите высоту контейнера */
    overflow: hidden; /* Обрезает изображение, выходящее за границы */
    background-color: rgb(240, 240, 240); /* Цвет фона для пустых аватаров */
    border-radius: 8px;
    border: 1px solid #718ebf;
`;

export const TableAvatarImage = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover; /* Обеспечивает заполнение контейнера изображением */
`;

const Avatar: FC<AvatarProps> = ({ url, size }) => {
    return <StyledAvatar size={size} url={url} />;
};

export default Avatar;

export const TableAvatar: FC<FileData | undefined> = (props) => (
    <TableAvatarContainer>
        {props?.url ? (
            <TableAvatarImage src={props.url} alt="Avatar" />
        ) : (
            <NoAvatar />
        )}
    </TableAvatarContainer>
);
